var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ListingWrapper",
    {
      staticClass: "activities-listing",
      attrs: {
        title: _vm.$t.__("common.labels.activities"),
        tabs: _vm.listingTabs,
        activeTab: _vm.activeTab,
        loading: _vm.loadingActivitiesPage
      },
      on: { "update:activeTab": _vm.handleSelectedTab }
    },
    [
      _c(
        "template",
        { slot: "settings" },
        [
          _c("ActivitiesListingSettingsHeader", {
            ref: "ActivitiesTable",
            attrs: { columns: _vm.getColumns, activeTab: _vm.activeTab },
            on: { updateColumns: _vm.handleUpdateColumns }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassMenu",
        { attrs: { slot: "listingActions" }, slot: "listingActions" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.create_activity"),
              dropdown: ""
            }
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "dropdown" },
            [
              _c(
                "CompassMenuItem",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleCreateActivity("task")
                    }
                  }
                },
                [
                  _c("CompassObject", {
                    attrs: {
                      value: "task",
                      size: "extra-small",
                      object: "task",
                      label: _vm.$t.__("common.labels.task")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("ActivitiesListingTable", {
        attrs: { slot: "table", isActivityPage: true, columns: _vm.getColumns },
        slot: "table"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }